import { createContext } from "@/composables/context";
import { TSiteDetails } from "@/data/api/kili/sites/types/sites.type";

export interface ISiteContext {
  readonly siteDetails?: TSiteDetails;
  readonly isLoading?: boolean;
}

export const SiteContext = createContext<ISiteContext>({
  siteDetails: undefined,
  isLoading: true,
});
